/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSet = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
      id
      title
      type
      setType
      description
      durations
      sequences
      owner
      exercises {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSets = /* GraphQL */ `
  query ListSets(
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        type
        setType
        description
        durations
        sequences
        owner
        exercises {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      userID
      set
      date
      duration
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        set
        date
        duration
        status
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const QueryByDate = /* GraphQL */ `
  query QueryByDate(
    $date: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    QueryByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        set
        date
        duration
        status
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserScheduledSet = /* GraphQL */ `
  query GetUserScheduledSet($id: ID!) {
    getUserScheduledSet(id: $id) {
      id
      userID
      day
      hour
      set
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUserScheduledSets = /* GraphQL */ `
  query ListUserScheduledSets(
    $filter: ModelUserScheduledSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserScheduledSets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        day
        hour
        set
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDefaultScheduledSet = /* GraphQL */ `
  query GetDefaultScheduledSet($id: ID!) {
    getDefaultScheduledSet(id: $id) {
      id
      day
      hour
      set
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDefaultScheduledSets = /* GraphQL */ `
  query ListDefaultScheduledSets(
    $filter: ModelDefaultScheduledSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDefaultScheduledSets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        hour
        set
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExercise = /* GraphQL */ `
  query GetExercise($id: ID!) {
    getExercise(id: $id) {
      id
      title
      favourite
      headline
      subtitle
      search
      target
      image
      icon
      mediaType
      videoID
      duration
      displayOrder
      displayDuration
      type
      color
      how
      equipment
      sets {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listExercises = /* GraphQL */ `
  query ListExercises(
    $filter: ModelExerciseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExercises(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        favourite
        headline
        subtitle
        search
        target
        image
        icon
        mediaType
        videoID
        duration
        displayOrder
        displayDuration
        type
        color
        how
        equipment
        sets {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivityHistory = /* GraphQL */ `
  query GetActivityHistory($id: ID!) {
    getActivityHistory(id: $id) {
      id
      userID
      duration
      date
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listActivityHistories = /* GraphQL */ `
  query ListActivityHistories(
    $filter: ModelActivityHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        duration
        date
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByUserIdAndDate = /* GraphQL */ `
  query ActivitiesByUserIdAndDate(
    $userID: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByUserIdAndDate(
      userID: $userID
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        duration
        date
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSetExercises = /* GraphQL */ `
  query GetSetExercises($id: ID!) {
    getSetExercises(id: $id) {
      id
      setID
      exerciseID
      set {
        id
        title
        type
        setType
        description
        durations
        sequences
        owner
        exercises {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      exercise {
        id
        title
        favourite
        headline
        subtitle
        search
        target
        image
        icon
        mediaType
        videoID
        duration
        displayOrder
        displayDuration
        type
        color
        how
        equipment
        sets {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSetExercises = /* GraphQL */ `
  query ListSetExercises(
    $filter: ModelSetExercisesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetExercises(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        setID
        exerciseID
        set {
          id
          title
          type
          setType
          description
          durations
          sequences
          owner
          createdAt
          updatedAt
          __typename
        }
        exercise {
          id
          title
          favourite
          headline
          subtitle
          search
          target
          image
          icon
          mediaType
          videoID
          duration
          displayOrder
          displayDuration
          type
          color
          how
          equipment
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
